import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: false,
    selector: 'no-label',
    templateUrl: './no-label.component.html',
})
export class NoLabelWrapperComponent extends FieldWrapper {
}
